import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import { SETUP_LINK_CHANNELS } from "@bindery/shared/contracts/orientation-secure";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const SETUP_LINK_PATH = `${ORIENTATION_API_PREFIX}/setup-link`;

// The aide types the parent's address or number; the reply never echoes it,
// and the one-time link never reaches the page.
export const setupLinkRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
  channel: z.enum(SETUP_LINK_CHANNELS),
  contact: z.string().trim().min(1).max(254),
  parentConsentAffirmed: z.literal(true),
});
export type SetupLinkRequest = z.infer<typeof setupLinkRequestSchema>;

export const setupLinkResponseSchema = z.object({
  status: z.literal("sent"),
  sendCount: z.number().int().min(1),
});
export type SetupLinkResponse = z.infer<typeof setupLinkResponseSchema>;
